"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductClick = exports.Name = void 0;
const Name = exports.Name = 'banner-click';
const ProductClick = exports.ProductClick = Name;
//# sourceMappingURL=index.js.map